

































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import StreakCount from 'frontend/views/userhome/components/StreakCount.vue';
import StreakCalendar from 'frontend/views/userhome/components/StreakCalendar.vue';
import { StreakCalendarDay, StreakNotificationType } from 'frontend/types';

@Component({
  components: {
    StreakCount,
    StreakCalendar,
  },
})
export default class StreakPopup extends Vue {
  @Prop(Number) private readonly currentStreak!: number;
  @Prop(Number) private readonly problemsSolvedInCurrentStreak!: number;
  @Prop(Boolean) private readonly isMobile!: boolean;
  @Prop(String) private readonly notificationType!: StreakNotificationType;
  @Prop(Boolean) private readonly visible!: boolean;
  @Prop(Boolean) private readonly isUserHome!: boolean;
  @Prop(Array) private readonly calendarDays!: StreakCalendarDay[];
  @Prop(Number) private readonly problemsRequiredPerDay!: number;
  @Prop(Boolean) private readonly completedTodaysStreak!: boolean;

  private get streakProgress(): number {
    return this.problemsSolvedInCurrentStreak < this.problemsRequiredPerDay
      ? this.problemsSolvedInCurrentStreak / this.problemsRequiredPerDay
      : 1;
  }

  private get hideCalendar(): boolean {
    return this.isUserHome || this.notificationType !== 'none';
  }

  private get streakCountSize(): string {
    if (this.notificationType !== 'none' || this.isMobile) {
      return 'medium';
    }
    return 'small';
  }

  private get showStreakDetails(): boolean {
    return (
      !this.completedTodaysStreak && (this.notificationType !== 'none' || this.streakProgress !== 1)
    );
  }

  private get streakDetailsVerb(): string {
    if (this.currentStreak === 0) {
      return 'start';
    }
    return 'build';
  }

  private get problemsLeftForStreak(): number {
    return this.problemsRequiredPerDay - this.problemsSolvedInCurrentStreak;
  }
}
